import { render, staticRenderFns } from "./histDiscipline.vue?vue&type=template&id=344953dc&"
import script from "./histDiscipline.vue?vue&type=script&lang=js&"
export * from "./histDiscipline.vue?vue&type=script&lang=js&"
import style0 from "./histDiscipline.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports